import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useNavigate } from 'react-router-dom';
import { useForm, SubmitHandler } from 'react-hook-form';
import { notifyMessage } from '../App';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { ICreateAppointment } from '../shared/interface/appointment.interface';
import { createAppointment, postPackage } from '../services/appointmentService';
import OTPInput from './auth/otpInput';


function PackageConfirmModal(props: any) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);

  const handleBookNow = async () => {
    try {
      if (props?.customerId && props?.doctorId && props?.selectedDate && props?.selectedTime) {
        const payload: ICreateAppointment = {
          doctor: Number(props?.doctorId),
          appointment_date: props?.selectedDate,
          time_alloted: props?.selectedTime,
          customer: props?.customerId,
        };
        const createRes = await createAppointment(payload);
        notifyMessage.SUCCESS(createRes?.message ?? 'Successfully created appointment');
        navigate(`/appointment/confirm/${createRes.data.id}`);
        setLoading(() => false);
        props?.setConfirmModalShow(false);
      } else {
        notifyMessage.WARN('Time slot or Date is missing!');
      }
    } catch (error: any) {
      setLoading(() => false);
      props?.setConfirmModalShow(false);
      notifyMessage.ERROR(error?.response?.data?.details?.non_field_errors?.[0] ?? error?.response?.data?.message ?? 'Something went wrong!');
    }
  };

  const handlePayNow = async (otpValue: any) => {
    if (props?.selectedPackage) {
      setLoading(() => true);
      const packageRes = await postPackage({ package_type: props?.selectedPackage, otp: otpValue });
      if (packageRes.data.GatewayPageURL[1].includes('/order-success')) {
        handleBookNow();
      } else {
        setLoading(() => false);
        props?.setConfirmModalShow(false);
        notifyMessage.ERROR('Oops! Credit purchase failed.');
      }
      // setLoading(() => false);
      // props?.setConfirmModalShow(false);
      // window.open(packageRes.data.GatewayPageURL[1], '_blank');
    } else {
      notifyMessage.WARN('Please select packages');
    }
  };

  const handleOtpChange = (otp: string) => {
    setValue('otp', otp);
  };

  const { register, handleSubmit, setValue, reset } = useForm<any>({
    resolver: yupResolver(yup.object().shape({})),
  });

  const onSubmit: SubmitHandler<FormData> = async (data: any) => {
    const otpValue = data.otp;
    if (props?.selectedPackage) {
      try {
        handlePayNow(otpValue);
      } catch (error: any) {
        setLoading(() => false);
        notifyMessage.ERROR(error?.response?.data?.details?.non_field_errors?.[0] ?? error?.response?.data?.message ?? 'Something went wrong!');

      }
    } else {
      notifyMessage.WARN('Please select packages');
    }
  };

  return (
    <Modal {...props} size='lg' aria-labelledby='contained-modal-title-vcenter' centered>
      <div className='modal-header py-3 bg-primary border-0'>
        <h6 className='text-white mb-0 font-pop-semibold'>Confirm Package Purchase</h6>
        <button onClick={() => props?.setConfirmModalShow(false)} type='button' className='btn text-white py-0 px-1'>
          <i className='fa-solid fa-xmark'></i>
        </button>
      </div>
      <Modal.Body>
        <div className='col-12 col-md-12 p-0 h-100 bg-light-100'>
          <div className='row align-items-center w-100 h-100 mx-0 py-5 overflow-y-auto'>
            <div className='col-12'>
              <div className='text-center mt-5'>
                <div className='row w-100 justify-content-center mx-0'>
                  <div className='col-md-8'>
                    <h5 className='text-secondary display-8 fw-semi-bold'>Enter OTP</h5>

                    <p className='text-gray-100 mb-4 mt-3'>
                      Enter OTP to Confirm Payment.
                    </p>
                    {/* <p className='text-gray-100 mb-4 mt-3'>
                          Check your mobile and enter the <br /> OTP code here
                        </p> */}
                    <div className='my-4'>
                      <form onSubmit={handleSubmit(onSubmit)}>
                        <div className='my-2'>
                          <OTPInput
                            autoFocus
                            isNumberInput
                            length={5}
                            className='otpContainer'
                            inputClassName='otpInput'
                            onChangeOTP={handleOtpChange}
                            {...register('otp')} // Register the OTP field with React Hook Form
                          />
                        </div>
                        <button type='submit' disabled={loading} className='btn btn-primary text-white w-100 rounded-3 my-4 my-4'>
                          {loading ? 'Loading...' : 'Confirm'}
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>

    </Modal>
  );
}

export default PackageConfirmModal;
